import { useSelector, useDispatch } from 'react-redux';
import Style from "./css/top_area.module.css";
import { useNavigate } from 'react-router-dom';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { setUser, removeUser } from '@/store/user/user';
import ToTalArea from "./total_area";
import MiddleArea from "./middle";

function TopArea() {
  let user = useSelector((state: any) => state.user);
  const chat = useSelector((state: any) => state.chat);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const movePage = (url: string) => {
    navigate(url);
  };

  const goLogOut = () => {
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/login/logout', {
      token_id: localStorage.intoyou_token,
    }, get_axios_data()).then((response) => {
      dispatch(removeUser());
      localStorage.removeItem("intoyou_token");
      navigate("/login");
    });
  };

  return (
    <>
      <ToTalArea
        Style={Style}
        chat={chat}
      ></ToTalArea>
      <MiddleArea></MiddleArea>
    </>
  );
}
export default TopArea;